/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getPenaltyList = (payload, callback) =>
  req.list(
    c.GET_PENALTY,
    'api/v1/rpt/administrator/settings/penalties',
    payload,
    callback
  );

  export const clearTransaction = () => req.setList(c.GET_PENALTY, []);

export const getSinglePenalty = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_PENALTY,
    `api/v1/rpt/administrator/settings/penalties/${id}`,
    payload,
    callback
  );

export const createPenalty = (payload, callback) =>
  req.create(
    c.CREATE_PENALTY,
    'api/v1/rpt/administrator/settings/penalties',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updatePenalty = (id, payload, callback) =>
  req.update(
    c.UPDATE_PENALTY,
    `api/v1/rpt/administrator/settings/penalties/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removePenalty = (id, payload, callback) =>
  req.remove(
    c.REMOVE_PENALTY,
    `api/v1/rpt/administrator/settings/penalties/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION,
    'api/v1/rpt/administrator/settings/ordinance_revisions',
    payload,
    callback
  );
  